"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CookieContainer {
    constructor() {
        this.values = {};
    }
    clear() {
        this.values = {};
    }
    delete(key) {
        if (this.values[key] !== undefined) {
            delete this.values[key];
            return true;
        }
        return false;
    }
    forEach(callbackfn, thisArg) {
        if (thisArg) {
            callbackfn = callbackfn.bind(thisArg);
        }
        for (const key of Object.getOwnPropertyNames(this.values)) {
            callbackfn(this.values[key], key, this);
        }
    }
    get(key) {
        return this.values[key];
    }
    has(key) {
        return this.get(key) !== undefined;
    }
    set(key, value) {
        this.values[key] = value;
        return this;
    }
}
exports.CookieContainer = CookieContainer;
//# sourceMappingURL=cookie.container.js.map